const isPlainObject = (val) =>
  val != null &&
  typeof val === "object" &&
  !Array.isArray(val) &&
  Object.getPrototypeOf(val) === Object.prototype;

/**
 * Deep-merges `override` onto `base`, skipping keys where override[key] === undefined.
 * If either side is not a plain object, returns override (non-plain objects and arrays replace wholesale).
 */
export const mergeProactiveModalContent = (base, override) => {
  if (override === undefined) return base;
  if (!isPlainObject(base) || !isPlainObject(override)) return override;

  const result = { ...base };
  for (const key of Object.keys(override)) {
    if (override[key] === undefined) continue;
    result[key] = mergeProactiveModalContent(base[key], override[key]);
  }
  return result;
};
